import { DestroyRef, Injectable, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { jeOsobniLinkKlijenta } from './osobni-link';

/** `<meta name="robots">` i `<meta name="referrer">` samo na osobnom linku klijenta. */
export const META_ROBOTS_OSOBNI_LINK = { name: 'robots', content: 'noindex, nofollow' } as const;
export const META_REFERRER_OSOBNI_LINK = { name: 'referrer', content: 'no-referrer' } as const;

/**
 * Na `/k` i `/k/**` postavlja `robots: noindex, nofollow` i `referrer: no-referrer`, a pri izlasku s
 * tih ruta ih uklanja. Nginx za `/k/` šalje ista pravila kao HTTP zaglavlja (`X-Robots-Tag`,
 * `Referrer-Policy`); ovo pokriva SPA navigaciju s javnog dijela na osobni link (dokument je
 * učitan na drugoj adresi, pa zaglavlja `/k/` nije ni dobio).
 *
 * Postavlja se već na `NavigationStart` (prije učitavanja stranice osobnog linka i njezinih zahtjeva),
 * a konačno stanje određuje `NavigationEnd` (`urlAfterRedirects`).
 *
 * Napomena: preglednik politiku Referera mijenja kad se meta umetne, a uklanjanje mete je ne vraća —
 * nakon posjeta osobnom linku dokument ostaje na `no-referrer` (strože, nikad blaže).
 */
@Injectable({ providedIn: 'root' })
export class OsobniLinkMetaService {
  private readonly router = inject(Router);
  private readonly meta = inject(Meta);
  private readonly destroyRef = inject(DestroyRef);
  private pokrenut = false;

  pokreni(): void {
    if (this.pokrenut) {
      return;
    }
    this.pokrenut = true;
    const pretplata = this.router.events.subscribe(e => {
      if (e instanceof NavigationStart) {
        if (jeOsobniLinkKlijenta(e.url)) {
          this.primijeni(e.url);
        }
      } else if (e instanceof NavigationEnd) {
        this.primijeni(e.urlAfterRedirects);
      }
    });
    this.destroyRef.onDestroy(() => pretplata.unsubscribe());
  }

  /** Postavi (osobni link) ili ukloni (ostalo) obje mete za URL; javno radi testova. */
  primijeni(url: string): void {
    if (jeOsobniLinkKlijenta(url)) {
      this.meta.updateTag({ ...META_ROBOTS_OSOBNI_LINK });
      this.meta.updateTag({ ...META_REFERRER_OSOBNI_LINK });
    } else {
      this.meta.removeTag(`name="${META_ROBOTS_OSOBNI_LINK.name}"`);
      this.meta.removeTag(`name="${META_REFERRER_OSOBNI_LINK.name}"`);
    }
  }
}
